export default __webpack_public_path__ + "static/media/60.88d33dad.png";